import { pluralizeToString } from 'lib/string/pluralize'
import { Metadata, TripMetadata } from 'tripPlanner/types/common'

export function getTripDescriptors(
  /** Why do we have two different metadata formats? 😬 */
  metadata: Metadata | TripMetadata | undefined,
) {
  if (!metadata) {
    return []
  }

  let days: number | undefined
  let places: number | undefined
  let countries: number | undefined

  if ('tripId' in metadata) {
    if (!metadata.counts) {
      return []
    }

    days = metadata.counts?.days
    places = metadata.counts?.locations
    countries = metadata.counts?.countries
  } else {
    days = metadata.days
    places = metadata.locations?.length
    countries = metadata.countries?.length
  }

  const descriptors: Array<string> = []
  if (days) {
    descriptors.push(pluralizeToString('day', days))
  }
  if (places) {
    descriptors.push(pluralizeToString('place', places))
  }
  if (countries) {
    descriptors.push(pluralizeToString('country', countries))
  }

  return descriptors
}
